var _defs, _circle, _path, _path2, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnowDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.5,
    x2: 21.5,
    y1: 19.67,
    y2: 28.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.12,
    x2: 31.88,
    y1: 43.48,
    y2: 46.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.67,
    x2: 32.33,
    y1: 42.69,
    y2: 47.31,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 23.12,
    x2: 24.88,
    y1: 43.48,
    y2: 46.52,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 22.67,
    x2: 25.33,
    y1: 42.69,
    y2: 47.31,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 37.12,
    x2: 38.88,
    y1: 43.48,
    y2: 46.52,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 36.67,
    x2: 39.33,
    y1: 42.69,
    y2: 47.31,
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 5,
    fill: "url(#b)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19 15.67V12.5m0 23v-3.17m5.89-14.22l2.24-2.24M10.87 32.13l2.24-2.24m0-11.78l-2.24-2.24m16.26 16.26l-2.24-2.24M7.5 24h3.17m19.83 0h-3.17"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 19 24; 360 19 24"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 00-19.11-8 7 7 0 00-10.57 6 7.21 7.21 0 00.1 1.14A7.5 7.5 0 0018 45.5a4.19 4.19 0 00.5 0v0h28a7 7 0 000-14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45,
    r: 1.25,
    fill: "none",
    stroke: "url(#a)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#d)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M33.17 46.25l-1.09-.63m-2.16-1.24l-1.09-.63M31 42.5v1.25m0 3.75v-1.25m-1.08-.63l-1.09.63m4.34-2.5l-1.09.63"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "4s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-1 -6; 1 12"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "9s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 31 45; 360 31 45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "4s",
    repeatCount: "indefinite",
    values: "0;1;1;1;0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 1.25,
    fill: "none",
    stroke: "url(#e)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#f)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M26.17 46.25l-1.09-.63m-2.16-1.24l-1.09-.63M24 42.5v1.25m0 3.75v-1.25m-1.08-.63l-1.09.63m4.34-2.5l-1.09.63"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    begin: "-2s",
    dur: "4s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -6; -1 12"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "9s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 24 45; 360 24 45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-2s",
    dur: "4s",
    repeatCount: "indefinite",
    values: "0;1;1;1;0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 45,
    r: 1.25,
    fill: "none",
    stroke: "url(#g)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#h)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M40.17 46.25l-1.09-.63m-2.16-1.24l-1.09-.63M38 42.5v1.25m0 3.75v-1.25m-1.08-.63l-1.09.63m4.34-2.5l-1.09.63"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    begin: "-1s",
    dur: "4s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -6; -1 12"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "9s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 38 45; 360 38 45"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1s",
    dur: "4s",
    repeatCount: "indefinite",
    values: "0;1;1;1;0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowDay);
export default __webpack_public_path__ + "static/media/snow-day.aa9fe108c5c9d0307b012f47d8886d97.svg";
export { ForwardRef as ReactComponent };